import { googleSignInService } from '@services/auth';
import { useMutation } from '@tanstack/react-query';
import mixpanel from 'mixpanel-browser';
import toast from 'react-hot-toast';
import { useMixpanel } from '../context/MixpanelProvider';
import { useUserAnalytics } from '../hooks/useUserAnalytics';
import { AUTH_EVENTS } from '../utils/eventSchema';

const useGoogleLogin = () => {
  const { trackEvent } = useUserAnalytics();
  const { aliasUser } = useMixpanel();
  return useMutation({
    mutationFn: ({ credential, rememberMe }) => {
      trackEvent('auth', {
        ...AUTH_EVENTS.LOGIN_STARTED,
        login_method: 'google',
        attempt_time: new Date().toISOString(),
        device: navigator.userAgent,
      });
      return googleSignInService({ credential, rememberMe });
    },
    onSuccess: (result) => {
      // Get anonymous ID before making the request
      const anonymousId = mixpanel.get_distinct_id();

      if (result?.user) {
        const { id } = result.user;

        // Link anonymous user to permanent user ID
        aliasUser(anonymousId, id);

        // Track successful Google sign-in
        trackEvent('auth', {
          ...AUTH_EVENTS.LOGIN_SUCCESSFUL,
          login_method: 'google',
          login_time: new Date().toISOString(),
          device: navigator.userAgent,
        });
      }
    },
    onError: (error) => {
      console.error('Google sign in failed:', error);
      toast.error(error.response?.data?.detail || 'Failed to sign in with Google');
    },
  });
};

export default useGoogleLogin;
